import axios from "axios";
import CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";
const { VITE_API_URL, DEV, VITE_WHAT_ID } = import.meta.env;
import dayjs from "dayjs";
import { getWhatId } from "../helpers/utils";

const isEncryptOn = true;
let aviGuid = localStorage.getItem("_uuid_rispromo") ? localStorage.getItem("_uuid_rispromo") : false;
let reqRange = localStorage.getItem("req_range") ? localStorage.getItem("req_range") : "";
let reqAbtest = localStorage.getItem("req_abtest") ? localStorage.getItem("req_abtest") : "";

if (!aviGuid) {
    aviGuid = uuidv4();
    localStorage.setItem("_uuid_rispromo", aviGuid);
}

let tokenUser = localStorage.getItem("token") ? localStorage.getItem("token") : false;

let headers = {
    "Content-Type": "application/json",
    "From-Site-Id": "680f46682d93763cd58b0260",
    "From-Site-Code": "showcase_promotional_codes",
    "Req-From": "web",
};

let headersDev = {
    "Content-Type": "application/json",
    "From-Site-Id": VITE_WHAT_ID,
    "From-Site-Code": "rispromo",
    "Req-From": "web",
};

if (aviGuid) {
    headers["Authorization"] = tokenUser ? tokenUser : aviGuid;
    headers["req-xid-token"] = aviGuid;
    headersDev["Authorization"] = tokenUser ? tokenUser : aviGuid;
    headersDev["req-xid-token"] = aviGuid;
}

if (reqRange) {
    headers["Req-Range"] = reqRange;
    headersDev["Req-Range"] = reqRange;
}

if (reqAbtest) {
    headers["Req-Abtest"] = reqAbtest;
    headersDev["Req-Abtest"] = reqAbtest;
}

const instance = axios.create({
    baseURL: VITE_API_URL,
    // baseURL: "http://localhost:6075/services",
    headers: DEV ? headersDev : headers,
    withCredentials: true,
    responseType: "json",
});

let xcfs = false;
instance.interceptors.response.use((response) => {
    if (response.headers["x-access-hash"]) {
        xcfs = response.headers["x-access-hash"];
    }
    return response;
});

instance.interceptors.request.use((config) => {
    config.headers["Req-Time"] = dayjs().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    config.headers["Req-Reg"] = "_unlu";
    if (xcfs) {
        config.headers["X-Access-Hash"] = xcfs;
    }
    const what_id = getWhatId();
    if (what_id) {
        config.headers["From-Site-Id"] = what_id;
    }
    return config;
});

const _getByUrl = async (url = "", params = "", reqHeaders = false, change_url = { baseURL: VITE_API_URL }) => {
    try {
        let paramsCda = "";
        const req_hash = generateHash({ t: dayjs().add(10, "second").format("YYYY-MM-DDTHH:mm:ss.SSSZ") }, _inSecret());
        instance.defaults.headers["req-hash"] = req_hash;
        if (reqHeaders) Object.entries(reqHeaders).forEach(([key, val]) => (instance.defaults.headers[key] = val));
        if (change_url) Object.entries(change_url).forEach(([key, val]) => (instance.defaults[key] = val));

        if (params) paramsCda = isEncryptOn ? `?cda=${generateHash(params, req_hash)}` : `?${new URLSearchParams(params)}`;

        let req = await instance.get(`${url}${paramsCda}`);
        if (req.data) {
            if (req.data.msg) console.log(req.data.msg);
            if (req.data._r_p_s) localStorage.setItem("_r_p_s", req.data._r_p_s);
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return e.response ? e.response : false;
    }
};
const _postByUrl = async (url, data, isCda, isFile) => {
    const req_hash = generateHash({ t: dayjs().add(10, "second").format("YYYY-MM-DDTHH:mm:ss.SSSZ") }, _inSecret());
    instance.defaults.headers["req-hash"] = req_hash;
    const extraParamsFile = isFile ? { headers: { ...headers, "Content-Type": "multipart/form-data;charset=UTF-8" } } : {};

    try {
        let req = await instance.post(url, isCda ? { cda: generateHash(data, req_hash) } : data, extraParamsFile);
        if (req.data) {
            if (req.data.msg) console.log(req.data.msg);
            if (req.data._r_p_s) localStorage.setItem("_r_p_s", req.data._r_p_s);
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return e.response ? e.response : false;
    }
};
const _putByUrl = async (url, data) => {
    try {
        let req = await instance.put(url, data);
        if (req.data) {
            if (req.data.msg) console.log(req.data.msg);
            if (req.data._r_p_s) localStorage.setItem("_r_p_s", req.data._r_p_s);
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return e.response ? e.response : false;
    }
};

const _deleteByUrl = async (url) => {
    try {
        let req = await instance.delete(url);
        if (req.data) {
            if (req.data.msg) console.log(req.data.msg);
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return e.response ? e.response : false;
    }
};

const _getWhatId = () => {
    const location_search = window && window.location && window.location.search ? window.location.search : {};
    const urlParams = new URLSearchParams(location_search);
    const what_id = urlParams.get("what_id");

    return what_id ? what_id : null;
};

const _initServiceAfterAuth = async (token) => {
    if (token) {
        instance.defaults.headers["Authorization"] = token;
    }
    return true;
};

// const _initServiceAfterCaptcha = async (token) => {
//     if (token) {
//         instance.defaults.headers["Req-Cap-Token"] = token;
//     }
//     return true;
// };

const generateHash = (data, hash) => encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data), hash).toString());

const _inSecret = () => {
    let returnguid = aviGuid.split("-").reverse();
    return `${returnguid[4]}[]${returnguid[3]}#${returnguid[0]}&${returnguid[2]}@${returnguid[1]}`;
};

export { _getByUrl, _postByUrl, _putByUrl, _deleteByUrl, _initServiceAfterAuth };
